export const Role = {
  RootAdmin: 'RootAdmin',
  Admin: 'Admin',
  User: 'User'
};
